import { useMemo } from "react";

export const useGetNow = () => {
  const now = useMemo(() => new Date(), []);
  return now;
};
